import Link from "next/link";
import { UrlObject } from "url";
import { Text, HStack, Stack } from "@chakra-ui/react";
import { FiArrowUpRight } from "@onemind-services-llc/react-icons-ng/fi";
import { TEXT_VARIANTS } from "@/theme/components/text";

type ContentProps = {
  link?: string | UrlObject;
  text: string;
};

export const ContentWithTextAndLink = (props: ContentProps) => {
  const { link, text } = props;
  const textVariant = TEXT_VARIANTS.BODY2;

  return (
    <Stack height={"100%"} justifyContent={"space-between"} spacing={4}>
      <Text color={"text.100"} variant={textVariant}>
        {text}
      </Text>
      {link && (
        <HStack as={Link} cursor={"pointer"} href={link} spacing={1}>
          <Text color={"primary.200"} fontWeight={600} variant={textVariant}>
            Explore more
          </Text>
          <FiArrowUpRight color="#1e87f0" fontSize={"24px"} />
        </HStack>
      )}
    </Stack>
  );
};
